import type {Builder} from '@wix/document-services-types'
import {STYLE} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import

export const STYLE_TYPE_MAP: Record<string, Builder.StyleItem> = {
    // CSS variables
    UnitSizeVar: {cssVariableType: STYLE.CSS_VARIABLE_TYPE.length},
    NumberVar: {cssVariableType: STYLE.CSS_VARIABLE_TYPE.number},

    // CSS properties
    JustifyContentVar: {cssPropertyType: STYLE.CSS_PROPERTY_TYPE.justifyContent},
    ItemsAlignmentVar: {cssPropertyType: STYLE.CSS_PROPERTY_TYPE.alignItems},
    OverflowVar: {cssPropertyType: STYLE.CSS_PROPERTY_TYPE.overflow}
}

// Skip styles that exist on the blocks side but are not yet supported
// by the component protocol specification
export const SKIP_STYLE_TYPE = {
    PositionTypeVar: {cssPropertyType: 'position'}
}
